import { vagasService } from '../../services'

export default {
  state: {
    lista_vagas: [],
    areas: [],
  },
  mutations: {
    setAreas(state, payload) {
      state.areas = payload
    },
    setListaVagas(state, payload) {
      state.lista_vagas = payload
    }
  },
  actions: {
    ultimasVagasLoad({ commit }, payload) {
      commit('setListaVagas', []);
      vagasService.VagasUltimas(payload).then(o => {
        commit('setListaVagas', o.obj);
      })
    },
    relacionadasVagasLoad({ commit }, payload) {
      commit('setListaVagas', []);
      vagasService.VagasRelacionadas(payload).then(o => {
        commit('setListaVagas', o.obj);
      })
    },
    vagasAreasLoad({ commit }, payload) {
      if (Array.isArray(this.getters.getAreas) && this.getters.getAreas.length == 0) {
        vagasService.VagasArea(payload).then(o => {
          commit('setAreas', o.obj)
        })
      }
    },
    setAreas({ commit }, payload) {
      commit('setAreas', payload.areas)
    },
  },
  getters: {
    getAreas(state) {
      return state.areas
    },
    getListaVagas(state) {
      return state.lista_vagas
    }
  }
}
